__turbopack_context__.v({
  "header": "PopularCitiesContainer-module-scss-module__gbyYVW__header",
  "root": "PopularCitiesContainer-module-scss-module__gbyYVW__root",
});
